import { render } from "./NewValidationDialogForm.vue?vue&type=template&id=0a8e58f4&scoped=true"
import script from "./NewValidationDialogForm.vue?vue&type=script&lang=js"
export * from "./NewValidationDialogForm.vue?vue&type=script&lang=js"

import "./NewValidationDialogForm.vue?vue&type=style&index=0&id=0a8e58f4&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8e58f4"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QChip from 'quasar/src/components/chip/QChip.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QChip});qInstall(script, 'directives', {ClosePopup});
